<img class="btn-download"
     src="assets/download_icon.svg"
     width="20" height="20"
     [class.disabled]="isDisable"
     (click)="!isDisable && onDownload()"
     alt="Télécharger">

